import React from 'react';

import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideContractChangeTerminate: React.FC = () => {
  return (
    <GuidePageLayout
      title="契約内容の変更・解除を申請する"
      description="稼働中の契約条件を変更する、または契約を終了します。"
      breadcrumbs={[{ label: '契約管理', path: '/guide/contract/overview' }]}
    >
      {/* 変更申請 */}
      <GuideSection title="契約内容の変更を申請する（BUC-CT02）">
        <GuideStepList
          steps={[
            { label: '契約一覧画面で対象契約を選択して詳細を表示する' },
            {
              label: '「契約内容変更」ボタンを押下して変更申請フォームを開く',
              content: (
                <GuideMockContainer label="契約詳細画面のボタン">
                  <GuideMockButton label="契約内容変更" variant="outlined" />
                </GuideMockContainer>
              ),
            },
            { label: '変更したい項目を修正する（担当者、金額、稼働率、契約終了日等）' },
            {
              label: '一時保存または申請を選択する',
              description: '申請の場合は有効開始日、申請者リスト、申請先リストを入力します。',
            },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox type="warning">
            契約開始日、プロジェクト、要員、課長は変更できません。
          </GuideInfoBox>
          <GuideInfoBox type="warning">
            1つの契約に対して進行中の申請は同時に1つのみです。既に申請中の場合はエラーとなります。
          </GuideInfoBox>
          <GuideInfoBox>有効開始日は変更後の契約条件が適用される月の初日です。</GuideInfoBox>
        </Stack>
      </GuideSection>

      {/* 解除申請 */}
      <GuideSection title="契約を解除する（BUC-CT03）">
        <GuideStepList
          steps={[
            { label: '契約一覧画面で対象契約を選択して詳細を表示する' },
            {
              label: '「契約終了」ボタンを押下する',
              content: (
                <GuideMockContainer label="契約詳細画面のボタン">
                  <GuideMockButton label="契約終了" color="error" variant="outlined" />
                </GuideMockContainer>
              ),
            },
            { label: '確認ダイアログで契約終了日を確認する' },
            { label: '申請者リストと申請先リストを入力する' },
            { label: '「申請」ボタンを押下する' },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox type="warning">解除申請は一時保存できません（即申請のみ）。</GuideInfoBox>
          <GuideInfoBox type="warning">
            1つの契約に対して進行中の申請は同時に1つのみです。
          </GuideInfoBox>
        </Stack>
      </GuideSection>

      <GuideSection title="前提条件（共通）">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者 / 管理部門 / 課長'],
            ['対象契約', 'ステータスがACTIVEであること'],
            ['申請状態', '対象契約に進行中の申請がないこと'],
          ]}
        />
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideContractChangeTerminate;
